import React from 'react';
import { Button, Result } from 'antd';

/**
 * 全局错误边界组件
 * 用于捕获应用中的所有错误，包括chunk加载错误
 */
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null,
      isChunkError: false
    };
  }

  static getDerivedStateFromError(error) {
    // 检查是否是chunk加载错误
    const isChunkError = error.message && (
      error.message.includes('Loading chunk') ||
      error.message.includes('ChunkLoadError') ||
      error.name === 'ChunkLoadError'
    );

    return { 
      hasError: true, 
      error,
      isChunkError
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('GlobalErrorBoundary caught an error:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // 如果是chunk加载错误，自动刷新页面
    if (this.state.isChunkError) {
      console.warn('Chunk loading error detected, will reload page in 2 seconds...');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleRetry = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null,
      isChunkError: false
    });
  };

  render() {
    if (this.state.hasError) {
      // 如果是chunk加载错误，显示特殊的错误页面
      if (this.state.isChunkError) {
        return (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: '#f5f5f5'
          }}>
            <Result
              status="warning"
              title="页面加载失败"
              subTitle="检测到资源加载错误，页面将在2秒后自动刷新..."
              extra={[
                <Button type="primary" key="reload" onClick={this.handleReload}>
                  立即刷新
                </Button>
              ]}
            />
          </div>
        );
      }

      // 其他类型的错误
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          background: '#f5f5f5'
        }}>
          <Result
            status="error"
            title="应用程序错误"
            subTitle="抱歉，应用程序遇到了一个错误。"
            extra={[
              <Button type="primary" key="retry" onClick={this.handleRetry}>
                重试
              </Button>,
              <Button key="reload" onClick={this.handleReload}>
                刷新页面
              </Button>
            ]}
          >
            {process.env.NODE_ENV === 'development' && (
              <div style={{ 
                textAlign: 'left', 
                background: '#f5f5f5', 
                padding: '16px', 
                borderRadius: '4px',
                marginTop: '16px'
              }}>
                <h4>错误详情（仅开发环境显示）：</h4>
                <pre style={{ fontSize: '12px', overflow: 'auto' }}>
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>
            )}
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
